import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api, { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/AuthLayout";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function AdminLogin() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin-pin", { pin });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Admin sign in" subtitle="For the organising team — view and analyse all contributions."
      footer={<Link to="/filltheform" data-testid="admin-login-home-link" className="font-semibold text-amber-800 hover:underline">← Back to the form</Link>}>
      <div className="flex items-center gap-2 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-900" data-testid="admin-login-banner"><ShieldCheck className="h-4 w-4" />Admin access only</div>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5"><Label>6-digit admin PIN</Label>
          <Input type="password" inputMode="numeric" autoComplete="current-password" autoFocus required minLength={6} pattern="\d{6}" value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} data-testid="admin-pin-input" className="h-14 text-center text-2xl tracking-[0.6em] font-mono" placeholder="••••••" /></div>
        {error && <p data-testid="login-error" className="text-sm text-rose-600">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="login-submit-button" className="w-full h-11 rounded-full bg-stone-900 hover:bg-stone-800">{loading ? "Checking..." : "Open admin panel"}</Button>
      </form>
    </AuthLayout>
  );
}
